import blackListProps from '../constants/blackListProps.js';
const isStyledPropsValid = props => !blackListProps[props];
export { isStyledPropsValid as default };
//# sourceMappingURL=isStyledPropsValid.js.map